module.exports = __webpack_public_path__ + "img/isamilo_lodge_gallery_16.77514842.jpeg";